import request from '@/utils/request'


// 查询配置列表
export function listDisposition(query) {
  return request({
    url: '/user/disposition/list',
    method: 'get',
    params: query
  })
}

// 查询配置分页
export function pageDisposition(query) {
  return request({
    url: '/user/disposition/page',
    method: 'get',
    params: query
  })
}

// 查询配置详细
export function getDisposition(data) {
  return request({
    url: '/user/disposition/detail',
    method: 'get',
    params: data
  })
}

// 新增配置
export function addDisposition(data) {
  return request({
    url: '/user/disposition/add',
    method: 'post',
    data: data
  })
}

// 修改配置
export function updateDisposition(data) {
  return request({
    url: '/user/disposition/edit',
    method: 'post',
    data: data
  })
}

// 删除配置
export function delDisposition(data) {
  return request({
    url: '/user/disposition/delete',
    method: 'post',
    data: data
  })
}
